import { render, staticRenderFns } from "./InvoiceDetailVirtualTable.vue?vue&type=template&id=96fd550a&scoped=true"
import script from "./InvoiceDetailVirtualTable.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailVirtualTable.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetailVirtualTable.vue?vue&type=style&index=0&id=96fd550a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fd550a",
  null
  
)

export default component.exports